import React from "react";
import styled from "styled-components";
import UserRequest from "./UserRequest";

const VideoBackground = styled.video`
  width: 100%;
  bottom: 0;
  position: absolute;
`;

const InfoContainer = styled.div`
  position: absolute;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const TextContainer = styled.div`
  padding: 0 40px;
  display: flex;
  gap: 24px;
  align-items: center;
`;

const Title = styled.p`
  font-size: 48px;
  color: #FFFFFF;
  font-family: DIN-RegularItalic,sans-serif !important;
  font-weight: 500;
`;

const Img = styled.img`
  width: 160px;
  height: 51px;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(12, 28, 53, 0.91) 0%, rgba(20, 36, 61, 0.00) 47.4%), linear-gradient(180deg, rgba(9, 19, 44, 0.64) 13.72%, rgba(64, 83, 134, 0.16) 73.57%);
`;

const Banner = () => {
  return <>
    <VideoBackground autoPlay loop muted>
      <source src={`${process.env.REACT_APP_ASSET_URL}/vedio/home-banner.mp4`} type="video/mp4" />
    </VideoBackground>
    <Overlay></Overlay>
    <InfoContainer>
      <TextContainer>
        <Title>FLY AIRACER</Title>
        <Img src="/imgs/svg/home/aircraft.svg" alt="aircraft"/>
      </TextContainer>
      <UserRequest />
    </InfoContainer>
  </>
}

export default Banner;